import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const AttachmentsLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    myAttachments: LazyLoadedStates,
}> ({
    base: {
        name: 'authenticated.attachments',
        url: '/attachments',
    },
    myAttachments: {
        name: 'authenticated.attachments.myattachments',
        url: '/my-attachments?page&start&end&searchBy&orderBy&ascending',
        params: {
            page: {
                raw: true,
                value: ''
            },
            searchBy: {
                raw: true,
                value: '',
            },
            start: {
                raw: true,
                value: '',
            },
            end: {
                raw: true,
                value: '',
            },
        },
    }
},
() => import('src/app/attachments/attachments.module').then(mod => mod.AttachmentsModule)
);
